import app from 'flarum/common/app';

/**
 * Resolve a URL canônica da página individual do produto.
 *
 *   1ª preferência: `/extension/{vendor}/{name}` (quando tem package_name)
 *   2ª preferência: `/item/{slug}`               (quando tem slug)
 *   3º recurso:     `/product/{id}`              (legado — redireciona no load)
 */
export function productUrl(product) {
  if (product.package_name && product.package_name.includes('/')) {
    const [vendor, name] = product.package_name.split('/');
    return app.route('marketplace.extension', {
      vendor,
      name
    });
  }
  if (product.slug) {
    return app.route('marketplace.item', {
      slug: product.slug
    });
  }
  return app.route('marketplace.product', {
    id: String(product.id)
  });
}
flarum.reg.add('ramon-marketplace', 'common/utils/productUrl', { productUrl: productUrl, });